export type DatabaseErrorTranslationKey =
  | 'anonymousSessionExpired'
  | 'captchaRequired'
  | 'databaseIdentityError'
  | 'databaseWriteRejected'
  | 'errorClearingData'
  | 'errorSavingGame'
  | 'quotaExceeded';

const databaseErrorMappings: Array<{
  key: DatabaseErrorTranslationKey;
  patterns: string[];
}> = [
  { key: 'captchaRequired', patterns: ['captcha'] },
  { key: 'quotaExceeded', patterns: ['quota'] },
  {
    key: 'anonymousSessionExpired',
    patterns: ['jwt expired', 'refresh token', 'anonymous session'],
  },
  {
    key: 'databaseWriteRejected',
    patterns: [
      'permission denied',
      'row-level security',
      'constraint',
      'invalid game',
    ],
  },
];

export const getDatabaseErrorTranslationKey = (
  error: unknown,
  fallback: DatabaseErrorTranslationKey
): DatabaseErrorTranslationKey => {
  const message = error instanceof Error
    ? error.message
    : typeof error === 'object' && error !== null && 'message' in error
      ? String(error.message)
      : '';
  const normalizedMessage = message.toLowerCase();

  const mapping = databaseErrorMappings.find(({ patterns }) =>
    patterns.some((pattern) => normalizedMessage.includes(pattern))
  );
  return mapping?.key ?? fallback;
};
